// imports
import { isMobile } from '../utils/isMobile';
import determineStickyState from '../utils/determineStickyState';

// globals
const $ = jQuery;

// native selectors
const productDetailPage = '.page-node-type-products-detail';
const productDescription =
  '.product-details__description .field--field-product-description';
const productContentClass = '.product-details__section-content';
const showMoreLink = '.product-details__description-show-more';

// classes
const showMoreClass = 'product-details__section-content--show-more';
const showMoreOpenClass = 'product-details__description-show-more-open';

// jquery selectors
const $productDetailPage = $(productDetailPage);
const $productDescription = $(productDescription);
const $showMoreLink = $(showMoreLink);
let lineHeight = $('.product-details__section-content p').css('line-height');
let descriptionHeight = $productDescription.outerHeight();
let contentHeight = parseInt(lineHeight) * 7;

// description section
const toggleHeight = () => {
  const showMore = () => {
    $productDescription
      .stop()
      .animate({ height: descriptionHeight }, 400, () => {
        $showMoreLink.addClass(showMoreOpenClass);
      });
  };

  const showLess = () => {
    $productDescription.stop().animate({ height: contentHeight }, 400, () => {
      $showMoreLink.removeClass(showMoreOpenClass);
    });
  };

  // hide on load
  if (isMobile()) showLess();

  // toggle on click
  $showMoreLink.on('click', () => {
    $showMoreLink.hasClass(showMoreOpenClass) ? showLess() : showMore();
  });
};

// description section
const checkHeight = () => {
  lineHeight = $('.product-details__section-content p').css('line-height');
  descriptionHeight = $productDescription.prop('scrollHeight');
  contentHeight = parseInt(lineHeight) * 7;

  if (descriptionHeight > contentHeight && isMobile()) {
    $productDescription.parents(productContentClass).addClass(showMoreClass);
    toggleHeight();
  } else {
    $productDescription.parents(productContentClass).removeClass(showMoreClass);

    $productDescription.css({ height: '' });
  }
};

const disableButton = () => {
  // @todo this should be cleaned up
  $('.button--product-details:not(.dialog-modal__trigger)').on(
    'click',
    function onClick(e) {
      e.preventDefault();
      const $this = $(this);
      const href = $this.attr('href');
      $this.attr('disabled', true);

      window.location = href;
    },
  );
};

(() => {
  if ($productDetailPage.length > 0 && isMobile()) {
    checkHeight();
    toggleHeight();
  }

  if ($productDetailPage.length > 0) {
    disableButton();
  }

  // track when the product image is being sticky
  determineStickyState('product-details__img');
})();

document.addEventListener('DOMContentLoaded', () => {
  let windowWidth = window.innerWidth;
  const onResize = () => {
    if (window.innerWidth === windowWidth) return;
    document.querySelector(productDescription).style.height = '';
    checkHeight();
    windowWidth = window.innerWidth;
  };

  if (document.querySelector(productDescription)) {
    window.addEventListener('resize', onResize);
  }
});
